/* eslint-disable */
import React from 'react'
import '../../printRole.css'
import http from '../Interceptor/Interseptor'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import Loader from '../loaders/loader'
import jMoment from 'moment-jalaali'
import {message} from 'antd'
export default class ParcelLabelPrint extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      list: []
    }
  }
  componentDidMount() {
    var urlParams = new URLSearchParams(window.location.search)
    const params = Object.fromEntries(urlParams)
    this.setState({
      loading: true
    })
    http
      .get(`${REPORT_DISPATCH.REPORT_DISPATCH_PARCEL_LABEL}`, {
        params: params
      })
      .then((response) => {
        if (response.data.error === null) {
          let res = response.data.object.result
          if (res.length > 0) {
            res.forEach((item) => {
              item.orderId = item.orderId.toString()
            })
            this.setState({
              list: res,
              loading: false
            })
          } else {
            console.log(`/report/parcel/label${this.props.location.search}`)
            this.props.history.push(`/report/parcel/label${this.props.location.search}`)
            message.error('موردی برای نمایش وجود ندارد')
          }
        } else {
          console.log(`/report/parcel/label${this.props.location.search}`)
          this.props.history.push(`/report/parcel/label${this.props.location.search}`)
          this.setState({
            loading: false
          })
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
          list: []
        })
      })
  }

  exportPrint = () => {
    setTimeout(() => {
      window.print()
    }, 500)
  }
  sum = (item) => {
    let initialVal = 0
    let sum = item.reduce(function(acc, current) {
      return Number(acc) + Number(current.quantity)
    }, initialVal)
    if (sum !== null) {
      return parseFloat(sum.toFixed(2))
    } else {
      return ''
    }
  }
  render() {
    const options = {
      width: 2,
      height: 30,
      format: 'CODE128',
      displayValue: false,
      fontOptions: '',
      font: 'monospace',
      textAlign: 'center',
      textPosition: 'top',
      textMargin: 2,
      fontSize: 20,
      background: 'transparent',
      lineColor: '#000',
      margin: 10,
      marginTop: undefined,
      marginBottom: undefined,
      marginLeft: undefined,
      marginRight: undefined
    }
    return (
      <div className="">
        <Loader show={this.state.loading} />
        <button className="printButton mb-2" onClick={this.exportPrint}>
          چاپ
        </button>
        <div className="wrapperRoles">
          {this.state.list.map((item) => (
            <>
              <div className="roleLabel">
                <div className="text-center" style={{marginBottom: '-10px'}}>
                  <h1 className="font-weight-bold mb-0" style={{fontSize: '7em', letterSpacing: '5px', lineHeight: 1}}>
                    {item.orderId.substr(2, item.orderId.length)}
                  </h1>
                </div>

                <div className="d-flex flex-row justify-content-between" style={{marginBottom: '-6px'}}>
                  <span>
                    <h2 className="font-weight-bold mb-0">
                      {item.shiftStartTime.substr(0, 2) + ' تا ' + item.shiftEndTime.substr(0, 2)}
                    </h2>
                  </span>
                  <span className="font-weight-bold">
                    <h3 className="mb-0 font-weight-bold" style={{letterSpacing: '2px', marginBottom: '-6px'}}>
                      {jMoment(item.shiftDate).format('jYY/jM/jD')}
                    </h3>
                  </span>
                </div>

                <div className="d-flex flex-row justify-content-between row mx-0">
                  <div className="col-12 p-0">
                    <div className="w-100 p-0" style={{marginBottom: '-3px'}}>
                      <span>رساننده : </span>
                      <>
                        {item.driverName && item.driverLastName !== false ? (
                          <span>
                            {item.driverName} {item.driverLastName}{' '}
                          </span>
                        ) : null}
                      </>
                    </div>

                    <div className="w-100 p-0 d-flex flex-row justify-content-between align-items-center align-content-center">
                      <p className="mb-0">
                        <span>خریدار : </span>
                        <span>{item.purchaser}</span>
                      </p>
                      <h6 className="mb-0 font-weight-bold" style={{letterSpacing: '2px', marginBottom: '0'}}>
                        {item.orderId}
                      </h6>
                    </div>
                  </div>
                  <div className="col-12 p-0" style={{marginBottom: '0'}}>
                    <span>آدرس : </span>
                    <span style={{lineHeight: 1}}>
                      {item.address !== null && item.address.length > 100
                        ? item.address.substr(0, 100) + '...'
                        : item.address}
                    </span>
                  </div>
                </div>

                {item.items.filter((i) => i.orderItemId !== null).length <= 6 ? (
                  <table className="w-100 mt-2 labelItems">
                    <tr>
                      <td className="text-center">#</td>
                      <td className="text-center small font-weight-bold">شرح</td>
                      <td className="text-center small font-weight-bold">تعداد</td>
                    </tr>
                    {item.items
                      .filter((i) => i.orderItemId !== null)
                      .map((ch, index) => (
                        <>
                          <tr className="">
                            <td className="small text-center">{index + 1}</td>
                            <td className="">
                              {ch.productTitle.length > 35 ? ch.productTitle.substr(0, 35) + '..' : ch.productTitle}
                            </td>
                            <td className="small text-center">{ch.quantity + ' ' + ch.productUnit}</td>
                          </tr>
                        </>
                      ))}
                  </table>
                ) : (
                  <div className="d-flex flex-column justify-content-center align-items-center justify-content-around">
                    <h2 className="mt-2 font-weight-bold text-center">
                      {item.items.filter((i) => i.orderItemId !== null).length + ' ردیف کالا '}
                    </h2>
                    <h2 className="mt-2 font-weight-bold text-center">
                      تعداد : {this.sum(item.items.filter((i) => i.orderItemId !== null))}
                    </h2>
                  </div>
                )}
              </div>
              <h1 className="breakHr" />
            </>
          ))}
        </div>
      </div>
    )
  }
}
